module.exports = __webpack_public_path__ + "assets/img/back.3fabe393.svg";